import { API_BASE_URL, parseJsonResponse } from './apiConfig'

async function fetchWithTimeout(resource, options = {}, timeout = 10000) {
  const controller = new AbortController()
  const id = setTimeout(() => controller.abort(), timeout)
  try {
    const response = await fetch(resource, {
      ...options,
      signal: controller.signal,
    })
    clearTimeout(id)
    return response
  } catch (error) {
    clearTimeout(id)
    throw error
  }
}

export async function fetchVisitorReport(startDate, endDate) {
  const params = new URLSearchParams()
  if (startDate) params.append('startDate', startDate)
  if (endDate) params.append('endDate', endDate)

  const response = await fetchWithTimeout(`${API_BASE_URL}/reports/visitors?${params}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })

  if (!response.ok) {
    throw new Error('Failed to fetch visitor report')
  }

  return parseJsonResponse(response, 'Failed to fetch visitor report')
}

export async function fetchAppointmentReport(startDate, endDate) {
  const params = new URLSearchParams()
  if (startDate) params.append('startDate', startDate)
  if (endDate) params.append('endDate', endDate)

  const response = await fetchWithTimeout(`${API_BASE_URL}/reports/appointments?${params}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })

  if (!response.ok) {
    throw new Error('Failed to fetch appointment report')
  }

  return parseJsonResponse(response, 'Failed to fetch appointment report')
}

export async function downloadVisitorCSV(startDate, endDate) {
  const params = new URLSearchParams()
  if (startDate) params.append('startDate', startDate)
  if (endDate) params.append('endDate', endDate)

  const response = await fetchWithTimeout(`${API_BASE_URL}/reports/visitors/csv?${params}`, {
    method: 'GET',
  })

  if (!response.ok) {
    throw new Error('Failed to download CSV')
  }

  const blob = await response.blob()
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `visitors_report_${new Date().toISOString().split('T')[0]}.csv`
  document.body.appendChild(a)
  a.click()
  window.URL.revokeObjectURL(url)
  document.body.removeChild(a)
}

export async function downloadAppointmentCSV(startDate, endDate) {
  const params = new URLSearchParams()
  if (startDate) params.append('startDate', startDate)
  if (endDate) params.append('endDate', endDate)

  const response = await fetchWithTimeout(`${API_BASE_URL}/reports/appointments/csv?${params}`, {
    method: 'GET',
  })

  if (!response.ok) {
    throw new Error('Failed to download appointment CSV')
  }

  const blob = await response.blob()
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `appointments_report_${new Date().toISOString().split('T')[0]}.csv`
  document.body.appendChild(a)
  a.click()
  window.URL.revokeObjectURL(url)
  document.body.removeChild(a)
}
